import React from "react";
import GenericDialog from "@components/GenericDialog/GenericDialog";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.delete.dialog`;

/**
 * DBCO-0065 - the confirmation before a Draft is deleted from the grid. Confirm is disabled and Cancel ignored
 * while the delete is pending, so a second click cannot send a second request and the dialog stays until the
 * call settles.
 */
const DeleteDraftDialog: React.FC<{
  open: boolean;
  isDeleting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ open, isDeleting = false, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <GenericDialog
      open={open}
      testId="drybulk-cargo-operations-delete-dialog"
      title={t(`${L}.title`)}
      content={t(`${L}.text`)}
      cancelButtonText={t(`${L}.cancel`)}
      confirmButtonText={t(`${L}.confirm`)}
      handleCloseDialog={onCancel}
      confirmAction={onConfirm}
      isSubmitting={isDeleting}
    />
  );
};

export default DeleteDraftDialog;
